define.alias("ember-useragent/services/user-agent", "preview-grid/services/user-agent");